<div
  id="app"
  class="h-100 app"
  [ngClass]="settings.theme"
  [class.main-toolbar-fixed]="settings.mainToolbarFixed"
  [dir]="settings.rtl ? 'rtl' : 'ltr'"
  style="transition: 0.5s"
  [style.opacity]="isServer ? 0 : 1"
>
  <router-outlet />
  <ngx-spinner
    #loadingScreen
    bdColor="rgba(51,51,51,0.7)"
    size="large"
    color="#fff"
    type="ball-clip-rotate"
  ></ngx-spinner>
  <app-loader *ngIf="loading"></app-loader>
</div>
